import {
  SimpleGrid,
  SimpleGridProps,
  useRadioGroup,
  UseRadioGroupProps,
} from "@chakra-ui/react";
import { Control, FieldValues, Path, useController } from "react-hook-form";

import {
  FieldWrapper,
  FieldWrapperPassThroughProps,
} from "@/components/Form/FieldWrapper.tsx";

import { RadioCard } from "./RadioCard";

type RadioGroupProps<TFieldValues extends FieldValues> = {
  options: string[];
  name: Path<TFieldValues>;
  control: Control<TFieldValues>;
  shouldUnregister?: boolean;
} & UseRadioGroupProps &
  FieldWrapperPassThroughProps &
  SimpleGridProps;

export const RadioGroup = <TFieldValues extends FieldValues>(
  props: RadioGroupProps<TFieldValues>,
) => {
  const {
    options,
    label,
    error,
    control,
    name,
    shouldUnregister = false,
    isRequired,
    openHelpModal,
  } = props;
  const { field } = useController({
    control,
    name,
    shouldUnregister,
  });
  const { getRadioProps } = useRadioGroup({ ...field });

  return (
    <FieldWrapper
      label={label}
      error={error}
      isRequired={isRequired}
      openHelpModal={openHelpModal}
    >
      <SimpleGrid
        width="fit-content"
        columns={options.length}
        gap={1}
        {...props}
      >
        {options.map((value) => {
          const radio = getRadioProps({ value });
          return (
            <RadioCard key={value} value={value} {...radio}>
              {value}
            </RadioCard>
          );
        })}
      </SimpleGrid>
    </FieldWrapper>
  );
};
